import React from "react";
import { motion } from "framer-motion";

import {
    FaFacebookF,
    FaTwitter,
    FaEnvelope,
    FaLinkedinIn,
    FaQuoteLeft,
    FaCode,
    FaGlobe,
    FaLightbulb,
    FaRocket,
    FaArrowRight,
} from "react-icons/fa";

import ceoHeaderImage from "./ceoimageheader.png";
import ceoImage from "./ceo.jpg";

import Footer from "./Footer";

const PrincipalMessagePage = () => {
    return (
        <div className="ceo-page">

            <style>{`

                .ceo-page {
                    width: 100%;
                    min-height: 100vh;
                    background: #f8fafc;
                    color: #111827;
                    font-family: "Poppins", "Inter", sans-serif;
                    overflow: hidden;
                }

                /* =====================================================
                   PAGE HEADER
                ===================================================== */

                .ceo-page-header {
                    position: relative;
                    width: 100%;
                    min-height: 440px;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    background: #111827;
                }

                .ceo-header-image {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: center;
                    opacity: 0.45;
                }

                .ceo-header-overlay {
                    position: absolute;
                    inset: 0;
                    background:
                        linear-gradient(
                            110deg,
                            rgba(15, 23, 42, 0.96) 0%,
                            rgba(15, 23, 42, 0.82) 45%,
                            rgba(15, 23, 42, 0.55) 100%
                        );
                }

                .ceo-header-orange-glow {
                    position: absolute;
                    width: 420px;
                    height: 420px;
                    right: -130px;
                    top: -170px;
                    border-radius: 50%;
                    background: rgba(249, 115, 22, 0.18);
                    filter: blur(5px);
                }

                .ceo-header-blue-glow {
                    position: absolute;
                    width: 300px;
                    height: 300px;
                    left: -120px;
                    bottom: -160px;
                    border-radius: 50%;
                    background: rgba(14, 165, 233, 0.15);
                }

                .ceo-header-lines {
                    position: absolute;
                    inset: 0;
                    opacity: 0.13;
                    background-image:
                        linear-gradient(
                            90deg,
                            rgba(255,255,255,0.15) 1px,
                            transparent 1px
                        ),
                        linear-gradient(
                            rgba(255,255,255,0.15) 1px,
                            transparent 1px
                        );
                    background-size: 70px 70px;
                }

                .ceo-header-content {
                    position: relative;
                    z-index: 5;
                    width: min(1250px, 90%);
                    margin: auto;
                    padding: 100px 0;
                }

                .ceo-header-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 9px;
                    padding: 9px 15px;
                    margin-bottom: 22px;
                    border: 1px solid rgba(249, 115, 22, 0.35);
                    border-radius: 30px;
                    background: rgba(249, 115, 22, 0.10);
                    color: #fed7aa;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                    backdrop-filter: blur(10px);
                }

                .ceo-header-badge svg {
                    color: #fb923c;
                }

                .ceo-header-content h1 {
                    max-width: 900px;
                    margin: 0;
                    color: #ffffff;
                    font-size: clamp(42px, 6vw, 78px);
                    line-height: 1.02;
                    font-weight: 900;
                    letter-spacing: -2.5px;
                }

                .ceo-header-content h1 span {
                    color: #f97316;
                }

                .ceo-header-content p {
                    max-width: 720px;
                    margin: 25px 0 0;
                    color: #cbd5e1;
                    font-size: 16px;
                    line-height: 1.9;
                }

                .ceo-header-bottom {
                    position: absolute;
                    z-index: 5;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    height: 7px;
                    display: flex;
                }

                .ceo-header-bottom span:nth-child(1) {
                    flex: 2;
                    background: #f97316;
                }

                .ceo-header-bottom span:nth-child(2) {
                    flex: 1;
                    background: #0ea5e9;
                }

                .ceo-header-bottom span:nth-child(3) {
                    flex: 1;
                    background: #ffffff;
                }

                /* =====================================================
                   INTRO SECTION
                ===================================================== */

                .ceo-intro-section {
                    position: relative;
                    padding: 110px 5%;
                    background:
                        radial-gradient(
                            circle at 10% 20%,
                            rgba(249, 115, 22, 0.07),
                            transparent 25%
                        ),
                        #f8fafc;
                }

                .ceo-intro-wrapper {
                    position: relative;
                    z-index: 2;
                    max-width: 1250px;
                    margin: auto;
                    display: grid;
                    grid-template-columns: 0.85fr 1.15fr;
                    gap: 75px;
                    align-items: center;
                }

                /* =====================================================
                   CEO PROFILE
                ===================================================== */

                .ceo-profile {
                    position: relative;
                }

                .ceo-image-frame {
                    position: relative;
                    max-width: 470px;
                    margin: auto;
                    padding: 12px;
                    border-radius: 30px;
                    background:
                        linear-gradient(
                            135deg,
                            #f97316,
                            #fb923c,
                            #0ea5e9
                        );
                    box-shadow:
                        0 30px 70px rgba(15, 23, 42, 0.14);
                }

                .ceo-image-inner {
                    position: relative;
                    overflow: hidden;
                    border-radius: 23px;
                    background: #ffffff;
                }

                .ceo-image {
                    display: block;
                    width: 100%;
                    height: 540px;
                    object-fit: cover;
                    object-position: center;
                    transition: transform 0.6s ease;
                }

                .ceo-image-frame:hover .ceo-image {
                    transform: scale(1.035);
                }

                .ceo-role-badge {
                    position: absolute;
                    left: 25px;
                    right: 25px;
                    bottom: 25px;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 15px 17px;
                    border-radius: 15px;
                    background: rgba(17, 24, 39, 0.92);
                    color: #ffffff;
                    backdrop-filter: blur(12px);
                    box-shadow:
                        0 15px 30px rgba(0, 0, 0, 0.20);
                }

                .ceo-role-icon {
                    width: 39px;
                    height: 39px;
                    min-width: 39px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 11px;
                    background: #f97316;
                    color: #ffffff;
                }

                .ceo-role-badge strong {
                    display: block;
                    font-size: 13px;
                }

                .ceo-role-badge span {
                    display: block;
                    margin-top: 2px;
                    color: #cbd5e1;
                    font-size: 10px;
                }

                .ceo-profile-details {
                    text-align: center;
                    margin-top: 25px;
                }

                .ceo-profile-details h3 {
                    margin: 0;
                    color: #111827;
                    font-size: 25px;
                    font-weight: 850;
                }

                .ceo-profile-details p {
                    margin: 7px 0 18px;
                    color: #f97316;
                    font-size: 12px;
                    font-weight: 700;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                }

                .ceo-social-icons {
                    display: flex;
                    justify-content: center;
                    gap: 9px;
                }

                .ceo-social-icons a {
                    width: 38px;
                    height: 38px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px;
                    color: #64748b;
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    text-decoration: none;
                    transition:
                        transform 0.25s ease,
                        color 0.25s ease,
                        background 0.25s ease;
                }

                .ceo-social-icons a:hover {
                    transform: translateY(-4px);
                    color: #ffffff;
                    background: #f97316;
                    border-color: #f97316;
                }

                /* =====================================================
                   MESSAGE
                ===================================================== */

                .ceo-message-area {
                    position: relative;
                }

                .ceo-message-card {
                    position: relative;
                    padding: 50px;
                    border-radius: 28px;
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    box-shadow:
                        0 25px 70px rgba(15, 23, 42, 0.07);
                }

                .ceo-quote-icon {
                    width: 58px;
                    height: 58px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 25px;
                    border-radius: 16px;
                    background: #fff7ed;
                    color: #f97316;
                    font-size: 22px;
                }

                .ceo-message-label {
                    margin-bottom: 10px;
                    color: #f97316;
                    font-size: 11px;
                    font-weight: 800;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                }

                .ceo-message-card h2 {
                    margin: 0 0 25px;
                    color: #111827;
                    font-size: clamp(30px, 4vw, 48px);
                    line-height: 1.1;
                    font-weight: 900;
                    letter-spacing: -1.5px;
                }

                .ceo-message-card h2 span {
                    color: #f97316;
                }

                .ceo-message-card p {
                    margin: 0 0 20px;
                    color: #64748b;
                    font-size: 14px;
                    line-height: 2;
                }

                .ceo-message-card p:first-of-type {
                    color: #334155;
                    font-size: 16px;
                }

                .ceo-signature {
                    margin-top: 32px;
                    padding-top: 25px;
                    border-top: 1px solid #e2e8f0;
                }

                .ceo-signature-name {
                    color: #111827;
                    font-size: 20px;
                    font-weight: 850;
                }

                .ceo-signature-role {
                    display: block;
                    margin-top: 5px;
                    color: #f97316;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                }

                /* =====================================================
                   COMPANY VALUES
                ===================================================== */

                .ceo-values-section {
                    padding: 95px 5%;
                    background: #ffffff;
                }

                .ceo-values-header {
                    max-width: 800px;
                    margin: 0 auto 50px;
                    text-align: center;
                }

                .ceo-values-header span {
                    color: #f97316;
                    font-size: 11px;
                    font-weight: 800;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                }

                .ceo-values-header h2 {
                    margin: 10px 0 12px;
                    color: #111827;
                    font-size: clamp(30px, 4vw, 45px);
                    font-weight: 900;
                    letter-spacing: -1.3px;
                }

                .ceo-values-header p {
                    margin: 0;
                    color: #64748b;
                    font-size: 14px;
                    line-height: 1.8;
                }

                .ceo-values-grid {
                    max-width: 1250px;
                    margin: auto;
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 20px;
                }

                .ceo-value-card {
                    position: relative;
                    padding: 30px 25px;
                    border-radius: 20px;
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    transition:
                        transform 0.3s ease,
                        box-shadow 0.3s ease,
                        border-color 0.3s ease;
                }

                .ceo-value-card:hover {
                    transform: translateY(-8px);
                    border-color: #fed7aa;
                    box-shadow:
                        0 20px 45px rgba(15, 23, 42, 0.08);
                }

                .ceo-value-icon {
                    width: 47px;
                    height: 47px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 18px;
                    border-radius: 13px;
                    color: #f97316;
                    background: #fff7ed;
                }

                .ceo-value-card:nth-child(2) .ceo-value-icon {
                    color: #0ea5e9;
                    background: #eff6ff;
                }

                .ceo-value-card:nth-child(3) .ceo-value-icon {
                    color: #8b5cf6;
                    background: #f5f3ff;
                }

                .ceo-value-card:nth-child(4) .ceo-value-icon {
                    color: #10b981;
                    background: #ecfdf5;
                }

                .ceo-value-card h3 {
                    margin: 0 0 9px;
                    color: #111827;
                    font-size: 16px;
                    font-weight: 800;
                }

                .ceo-value-card p {
                    margin: 0;
                    color: #64748b;
                    font-size: 12px;
                    line-height: 1.75;
                }

                /* =====================================================
                   SIGNATURE CTA
                ===================================================== */

                .ceo-cta {
                    position: relative;
                    max-width: 1250px;
                    margin: 0 auto 100px;
                    padding: 55px;
                    border-radius: 28px;
                    overflow: hidden;
                    background:
                        linear-gradient(
                            120deg,
                            #111827,
                            #1e293b
                        );
                    box-shadow:
                        0 25px 60px rgba(15, 23, 42, 0.14);
                }

                .ceo-cta::before {
                    content: "";
                    position: absolute;
                    width: 350px;
                    height: 350px;
                    right: -100px;
                    top: -170px;
                    border-radius: 50%;
                    background: rgba(249, 115, 22, 0.18);
                }

                .ceo-cta-content {
                    position: relative;
                    z-index: 2;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 35px;
                }

                .ceo-cta h2 {
                    margin: 0 0 10px;
                    color: #ffffff;
                    font-size: clamp(25px, 4vw, 38px);
                    font-weight: 850;
                }

                .ceo-cta p {
                    max-width: 700px;
                    margin: 0;
                    color: #cbd5e1;
                    font-size: 13px;
                    line-height: 1.8;
                }

                .ceo-cta-button {
                    display: inline-flex;
                    align-items: center;
                    gap: 10px;
                    padding: 14px 20px;
                    border-radius: 11px;
                    background: #f97316;
                    color: #ffffff;
                    text-decoration: none;
                    font-size: 12px;
                    font-weight: 800;
                    white-space: nowrap;
                    transition:
                        transform 0.25s ease,
                        background 0.25s ease;
                }

                .ceo-cta-button:hover {
                    transform: translateY(-3px);
                    background: #ea580c;
                }

                /* =====================================================
                   RESPONSIVE
                ===================================================== */

                @media (max-width: 1000px) {

                    .ceo-intro-wrapper {
                        grid-template-columns: 1fr;
                        gap: 55px;
                    }

                    .ceo-profile {
                        max-width: 550px;
                        width: 100%;
                        margin: auto;
                    }

                    .ceo-values-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }

                    .ceo-message-card {
                        padding: 40px;
                    }

                }

                @media (max-width: 700px) {

                    .ceo-page-header {
                        min-height: 400px;
                    }

                    .ceo-header-content {
                        padding: 80px 0;
                    }

                    .ceo-header-content h1 {
                        font-size: 43px;
                        letter-spacing: -1.5px;
                    }

                    .ceo-header-content p {
                        font-size: 13px;
                        line-height: 1.8;
                    }

                    .ceo-intro-section {
                        padding: 70px 5%;
                    }

                    .ceo-image {
                        height: 450px;
                    }

                    .ceo-message-card {
                        padding: 30px 23px;
                        border-radius: 22px;
                    }

                    .ceo-values-section {
                        padding: 70px 5%;
                    }

                    .ceo-values-grid {
                        grid-template-columns: 1fr;
                    }

                    .ceo-cta {
                        margin: 0 5% 70px;
                        padding: 35px 25px;
                    }

                    .ceo-cta-content {
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .ceo-cta-button {
                        width: 100%;
                        justify-content: center;
                    }

                }

                @media (max-width: 430px) {

                    .ceo-header-content h1 {
                        font-size: 36px;
                    }

                    .ceo-image {
                        height: 390px;
                    }

                    .ceo-role-badge {
                        left: 15px;
                        right: 15px;
                        bottom: 15px;
                    }

                    .ceo-message-card h2 {
                        font-size: 31px;
                    }

                }

                @media (prefers-reduced-motion: reduce) {

                    .ceo-page *,
                    .ceo-page *::before,
                    .ceo-page *::after {
                        animation: none !important;
                        transition: none !important;
                    }

                }

            `}</style>

            {/* =========================================================
                PAGE HEADER
            ========================================================= */}

            <section className="ceo-page-header">

                <img
                    src={ceoHeaderImage}
                    alt="POLU TECH technology"
                    className="ceo-header-image"
                />

                <div className="ceo-header-overlay"></div>

                <div className="ceo-header-lines"></div>

                <div className="ceo-header-orange-glow"></div>

                <div className="ceo-header-blue-glow"></div>

                <div className="ceo-header-content">

                    <motion.div
                        className="ceo-header-badge"
                        initial={{
                            opacity: 0,
                            y: 20
                        }}
                        animate={{
                            opacity: 1,
                            y: 0
                        }}
                        transition={{
                            duration: 0.7
                        }}
                    >
                        <FaCode />

                        CEO & FOUNDER MESSAGE
                    </motion.div>

                    <motion.h1
                        initial={{
                            opacity: 0,
                            y: 35
                        }}
                        animate={{
                            opacity: 1,
                            y: 0
                        }}
                        transition={{
                            duration: 0.8,
                            delay: 0.1
                        }}
                    >
                        Building the Future
                        <br />
                        <span>Through Technology.</span>
                    </motion.h1>

                    <motion.p
                        initial={{
                            opacity: 0,
                            y: 25
                        }}
                        animate={{
                            opacity: 1,
                            y: 0
                        }}
                        transition={{
                            duration: 0.8,
                            delay: 0.2
                        }}
                    >
                        A message from Chris B. Sati, Founder of GLOJES
                        and POLU-Tech, on innovation, digital transformation,
                        creativity, and the vision behind building technology
                        that creates meaningful impact.
                    </motion.p>

                </div>

                <div className="ceo-header-bottom">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

            </section>

            {/* =========================================================
                CEO MESSAGE
            ========================================================= */}

            <section className="ceo-intro-section">

                <div className="ceo-intro-wrapper">

                    <motion.div
                        className="ceo-profile"
                        initial={{
                            opacity: 0,
                            x: -70
                        }}
                        whileInView={{
                            opacity: 1,
                            x: 0
                        }}
                        transition={{
                            duration: 0.8
                        }}
                        viewport={{
                            once: true
                        }}
                    >

                        <div className="ceo-image-frame">

                            <div className="ceo-image-inner">

                                <img
                                    src={ceoImage}
                                    alt="Chris B. Sati - Founder of GLOJES and POLU-Tech"
                                    className="ceo-image"
                                />

                                <div className="ceo-role-badge">

                                    <div className="ceo-role-icon">
                                        <FaRocket />
                                    </div>

                                    <div>

                                        <strong>
                                            Founder & CEO
                                        </strong>

                                        <span>
                                            GLOJES • POLU-Tech
                                        </span>

                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="ceo-profile-details">

                            <h3>
                                Chris B. Sati
                            </h3>

                            <p>
                                Founder • CEO • Technology Innovator
                            </p>

                            <div className="ceo-social-icons">

                                <a
                                    href="#"
                                    aria-label="Facebook"
                                >
                                    <FaFacebookF />
                                </a>

                                <a
                                    href="#"
                                    aria-label="Twitter"
                                >
                                    <FaTwitter />
                                </a>

                                <a
                                    href="mailto:info@polutechsms.com"
                                    aria-label="Email"
                                >
                                    <FaEnvelope />
                                </a>

                                <a
                                    href="#"
                                    aria-label="LinkedIn"
                                >
                                    <FaLinkedinIn />
                                </a>

                            </div>

                        </div>

                    </motion.div>

                    <motion.div
                        className="ceo-message-area"
                        initial={{
                            opacity: 0,
                            x: 70
                        }}
                        whileInView={{
                            opacity: 1,
                            x: 0
                        }}
                        transition={{
                            duration: 0.8
                        }}
                        viewport={{
                            once: true
                        }}
                    >

                        <div className="ceo-message-card">

                            <div className="ceo-quote-icon">
                                <FaQuoteLeft />
                            </div>

                            <div className="ceo-message-label">
                                A Message From Our Founder
                            </div>

                            <h2>
                                Technology Should
                                <br />
                                <span>Move People Forward.</span>
                            </h2>

                            <p>
                                Welcome to GLOJES and POLU-Tech.
                                I am Chris B. Sati, and it is a privilege
                                to share the vision behind the work we are
                                building.
                            </p>

                            <p>
                                I believe technology is more than writing
                                code or creating beautiful interfaces.
                                Technology is about solving real problems,
                                creating opportunities, connecting people,
                                and developing systems that make everyday
                                work more efficient.
                            </p>

                            <p>
                                Our journey is driven by a simple principle:
                                build technology that is useful, reliable,
                                scalable, and capable of creating meaningful
                                impact. From websites and software platforms
                                to databases, APIs, management systems, and
                                digital solutions, our goal is to turn ideas
                                into working solutions.
                            </p>

                            <p>
                                At POLU-Tech, we are continuously exploring
                                new technologies and developing better ways
                                to serve organizations, businesses,
                                institutions, entrepreneurs, and individuals
                                who are ready to embrace digital
                                transformation.
                            </p>

                            <p>
                                The future belongs to those who are willing
                                to learn, create, adapt, and build. My vision
                                is to help create that future by developing
                                technology from Africa that can solve local
                                challenges while meeting global standards.
                            </p>

                            <p>
                                Thank you for believing in innovation,
                                creativity, and the power of technology.
                                Together, we can build something meaningful.
                            </p>

                            <div className="ceo-signature">

                                <div className="ceo-signature-name">
                                    Chris B. Sati
                                </div>

                                <span className="ceo-signature-role">
                                    Founder of GLOJES & POLU-Tech
                                </span>

                            </div>

                        </div>

                    </motion.div>

                </div>

            </section>

            {/* =========================================================
                VISION / VALUES
            ========================================================= */}

            <section className="ceo-values-section">

                <div className="ceo-values-header">

                    <span>
                        OUR TECHNOLOGY PHILOSOPHY
                    </span>

                    <h2>
                        What We Believe
                    </h2>

                    <p>
                        The foundation behind the products, systems,
                        and digital experiences we create.
                    </p>

                </div>

                <div className="ceo-values-grid">

                    <motion.div
                        className="ceo-value-card"
                        whileHover={{
                            y: -8
                        }}
                    >

                        <div className="ceo-value-icon">
                            <FaLightbulb />
                        </div>

                        <h3>
                            Innovation
                        </h3>

                        <p>
                            We continuously explore new ideas,
                            technologies, and approaches to solve
                            complex problems.
                        </p>

                    </motion.div>

                    <motion.div
                        className="ceo-value-card"
                        whileHover={{
                            y: -8
                        }}
                    >

                        <div className="ceo-value-icon">
                            <FaCode />
                        </div>

                        <h3>
                            Quality Code
                        </h3>

                        <p>
                            We believe strong software should be
                            structured, maintainable, secure, and
                            designed to grow.
                        </p>

                    </motion.div>

                    <motion.div
                        className="ceo-value-card"
                        whileHover={{
                            y: -8
                        }}
                    >

                        <div className="ceo-value-icon">
                            <FaGlobe />
                        </div>

                        <h3>
                            Global Vision
                        </h3>

                        <p>
                            We build with local challenges in mind
                            while maintaining standards suitable for
                            the wider digital world.
                        </p>

                    </motion.div>

                    <motion.div
                        className="ceo-value-card"
                        whileHover={{
                            y: -8
                        }}
                    >

                        <div className="ceo-value-icon">
                            <FaRocket />
                        </div>

                        <h3>
                            Impact
                        </h3>

                        <p>
                            Every solution should create practical
                            value and help people, organizations,
                            and businesses move forward.
                        </p>

                    </motion.div>

                </div>

            </section>

            {/* =========================================================
                CTA
            ========================================================= */}

            <section className="ceo-cta">

                <div className="ceo-cta-content">

                    <div>

                        <h2>
                            Have an Idea? Let's Build It.
                        </h2>

                        <p>
                            Whether you need a website, software system,
                            database, API, school management platform,
                            business solution, or a completely new
                            digital product, POLU-Tech is ready to turn
                            your idea into technology.
                        </p>

                    </div>

                    <a
                        href="#contact"
                        className="ceo-cta-button"
                    >
                        Start a Project
                        <FaArrowRight />
                    </a>

                </div>

            </section>

            <Footer />

        </div>
    );
};

export default PrincipalMessagePage;